import type { ICustomControlData } from './TcorV1DiagnosticReportAddEditCustomControlFields';
import { ReadAfwijkingen, showAfwijkingen } from '../../TCCr/v1/CardioAfwijkingen';

export function TcorV1DiagnosticReportReadCustomControlFields(props: {
    customControlData: ICustomControlData;
    txcsProcesId: string | null;
}) {
    return (
        <>
            {showAfwijkingen(props.txcsProcesId, props.customControlData) && (
                <ReadAfwijkingen afwijkingen={props.customControlData} />
            )}
        </>
    );
}
